import React from "react";

import useTrackEvent from "../hooks/useTrackEvent";
import { IntegrationCategory } from "../providers/AnalyticsContext";

import type { SendTrackEvent } from "../types";

interface WithTrackEventProps {
  trackAdEvent: SendTrackEvent;
  trackEvent: SendTrackEvent;
}

export default function withTrackEvent<T>(
  WrappedComponent: React.ComponentType<T & WithTrackEventProps>
) {
  return (props: T) => {
    const trackEvent = useTrackEvent();
    const trackAdEvent = useTrackEvent(IntegrationCategory.Advertising);

    return (
      <WrappedComponent
        trackAdEvent={trackAdEvent}
        trackEvent={trackEvent}
        {...(props as T)}
      />
    );
  };
}
